/*eslint-disable no-useless-constructor */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import TimeZoneDateFormat from './timezone/timezone';
import SuppressFields from './suppressfields/suppressfields';
//import FindProviderSettings from './FindProviderSetting/FindProviderSettings';
import ClaimsConfigurationTable from './ClaimsLableConfiguration/ClaimsConfigurationTable';
import FeaturesConfigurationTable from './FeaturesConfiguration/FeaturesConfigurationTable';
import Demographic from './demographic/demographic';
import SessionTimeout from './sessiontimeout/sessiontimeout';
import Header from '../../components/common/Header/Header';
import { ToastContainer, toast } from 'react-toastify';

import 'react-web-tabs/dist/react-web-tabs.css';
import './myprofile.scss';
import './preference.scss';
import ConfigurationTable from './configurationTable/configurationTable';

class Preference extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Container fluid className="claims-details">
          <Header
            linkTo={'/admin/admin-dashboard'}
            header={t('admin.pages.portal_settings.module')}
          />

          <Row>
            <Col>
              <Tabs defaultTab="vertical-tab-one" vertical>
                <TabList>
                  <Tab tabFor="vertical-tab-one" role="navigation">
                    Date Format
                  </Tab>
                  <Tab tabFor="vertical-tab-two" role="navigation">
                    Suppress Fields
                  </Tab>
                  {/*<Tab tabFor="vertical-tab-three" role="navigation">Network Setting</Tab>
                  <Tab tabFor="vertical-tab-four" role="navigation">Network Configuration</Tab>
                  <Tab tabFor="vertical-tab-five" role="navigation">Claim Labels Configuration</Tab>
                  <Tab tabFor="vertical-tab-six" role="navigation">Features Configuration</Tab> */}
                  {/*<Tab tabFor="vertical-tab-four" role="navigation">Find Provider Setting</Tab>
                  <Tab tabFor="vertical-tab-five" role="navigation">Features Setting</Tab>
                  <Tab tabFor="vertical-tab-three" role="navigation">Session Time Out</Tab>
                  <Tab tabFor="vertical-tab-four" role="navigation">Demographic Information</Tab> */}
                </TabList>

                <TabPanel tabId="vertical-tab-one" className="personal-info">
                  <TimeZoneDateFormat />
                </TabPanel>

                <TabPanel tabId="vertical-tab-two" className="personal-info">
                  <SuppressFields />
                </TabPanel>

                {/*<TabPanel tabId="vertical-tab-three" className="personal-info">
                  <NetworkSettings />
                </TabPanel>

                <TabPanel tabId="vertical-tab-four" className="personal-info">
                  <ConfigurationTable />
                </TabPanel>

                <TabPanel tabId="vertical-tab-five" className="personal-info">
                  <ClaimsConfigurationTable />
                </TabPanel>

                <TabPanel tabId="vertical-tab-six" className="personal-info">
                  <FeaturesConfigurationTable />
                </TabPanel> */}

                {/*<TabPanel tabId="vertical-tab-four" className="personal-info">
                  <FindProviderSettings />
                </TabPanel>

                <TabPanel tabId="vertical-tab-five" className="personal-info">
                  <SuppressFields />
                </TabPanel> */}

                {/*<TabPanel
                  tabId="vertical-tab-three"
                  className="personal-info"
                >
                  <SessionTimeout />
                </TabPanel>
                <TabPanel tabId="vertical-tab-four" className="personal-info">
                  <Demographic />
                </TabPanel> */}
              </Tabs>
              <div className="toastify">
                <ToastContainer
                  draggable
                  pauseOnHover
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  autoClose={5000}
                  position="top-center"
                  newestOnTop={false}
                  hideProgressBar={false}
                  className="toastcontainer"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Preference);
